import { socialConnect as service } from '../base/services';
import Endpoint from '../base/endpoint';

const connectBySpotId = new Endpoint(
  service,
  'get',
  '/{{socialNetwork}}?spot_id={{spotId}}&spot_token={{token}}'
);
const connectByNetworkId = new Endpoint(
  service,
  'get',
  '/{{socialNetwork}}?network_id={{networkId}}&spot_token={{token}}'
);
const toggleDisqusClaim = new Endpoint(service, 'post', '/internal/toggle-disqus-claim/{{spotId}}');

export default {
  connectBySpotId,
  connectByNetworkId,
  toggleDisqusClaim
};
